"use strict";
exports.__esModule = true;
exports.fromCeloResourcesRaw = exports.toCeloResourcesRaw = void 0;
var bignumber_js_1 = require("bignumber.js");
function toCeloResourcesRaw(r) {
    var _a = r !== null && r !== void 0 ? r : {}, registrationStatus = _a.registrationStatus, lockedBalance = _a.lockedBalance, nonvotingLockedBalance = _a.nonvotingLockedBalance, pendingWithdrawals = _a.pendingWithdrawals, votes = _a.votes, electionAddress = _a.electionAddress, lockedGoldAddress = _a.lockedGoldAddress, maxNumGroupsVotedFor = _a.maxNumGroupsVotedFor;
    return {
        registrationStatus: registrationStatus,
        lockedBalance: lockedBalance === null || lockedBalance === void 0 ? void 0 : lockedBalance.toString(),
        nonvotingLockedBalance: nonvotingLockedBalance === null || nonvotingLockedBalance === void 0 ? void 0 : nonvotingLockedBalance.toString(),
        pendingWithdrawals: pendingWithdrawals === null || pendingWithdrawals === void 0 ? void 0 : pendingWithdrawals.map(function (withdrawal) { return ({
            value: withdrawal.value.toString(),
            time: withdrawal.time.toString(),
            index: withdrawal.index.toString()
        }); }),
        votes: votes === null || votes === void 0 ? void 0 : votes.map(function (vote) { return ({
            validatorGroup: vote.validatorGroup.toString(),
            amount: vote.amount.toString(),
            activatable: vote.activatable,
            revokable: vote.revokable,
            type: vote.type,
            index: vote.index
        }); }),
        electionAddress: electionAddress,
        lockedGoldAddress: lockedGoldAddress,
        maxNumGroupsVotedFor: maxNumGroupsVotedFor === null || maxNumGroupsVotedFor === void 0 ? void 0 : maxNumGroupsVotedFor.toString()
    };
}
exports.toCeloResourcesRaw = toCeloResourcesRaw;
function fromCeloResourcesRaw(r) {
    var _a, _b;
    return {
        registrationStatus: r.registrationStatus,
        lockedBalance: new bignumber_js_1.BigNumber(r.lockedBalance),
        nonvotingLockedBalance: new bignumber_js_1.BigNumber(r.nonvotingLockedBalance),
        pendingWithdrawals: (_a = r.pendingWithdrawals) === null || _a === void 0 ? void 0 : _a.map(function (u) { return ({
            value: new bignumber_js_1.BigNumber(u.value),
            time: new bignumber_js_1.BigNumber(u.time),
            index: Number(u.index)
        }); }),
        votes: (_b = r.votes) === null || _b === void 0 ? void 0 : _b.map(function (vote) { return ({
            validatorGroup: vote.validatorGroup,
            amount: new bignumber_js_1.BigNumber(vote.amount),
            activatable: vote.activatable,
            revokable: vote.revokable,
            type: vote.type,
            index: vote.index
        }); }),
        electionAddress: r.electionAddress,
        lockedGoldAddress: r.lockedGoldAddress,
        maxNumGroupsVotedFor: new bignumber_js_1.BigNumber(r.maxNumGroupsVotedFor)
    };
}
exports.fromCeloResourcesRaw = fromCeloResourcesRaw;
//# sourceMappingURL=serialization.js.map